export default "__VITE_ASSET__B_iYs7MJ__"